import React, { useContext, useEffect, useState } from 'react';
import { ReorderConstants } from '../Constants/ReorderConstants';
import Modal from 'molecules/Modal';
import ReorderConfirmationModel from '../Presentation/ReorderConfirmationModel';
import { isEmptyObject, isMobileDevice } from 'common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import QuickReorderModal from '../Presentation/QuickReorderModal';
import ProceedToPayment from 'components/checkout/proceedToPayment';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import StartOrderContants from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import CouponsModal from '../../CouponsLanding/Presentation/CouponsModal';
import { removeAllCouponAction, removeAllItemAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { addToPaymentClickHandler } from 'components/checkout/PaymentDispatchFn';
import { UserOrderContext } from 'context/context';

export const getUserDetails = customerObj => {
  const customerObject = { ...customerObj };
  const { firstName = '', middleName = '', lastName = '', email = '', phone = '' } = customerObject;

  const fullName = (firstName || '') + (middleName || '') + (lastName || '');

  return {
    fullName,
    email,
    phone,
  };
};

const ReorderComponent = props => {
  const { reorderModalOpen, setReorderModalOpen, isQuickReorderModalOpen, setQuickReorderModalOpen, storeInfo } = props;
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const dispatch = useDispatch();
  const { QUICK_ORDER, CHECKOUT, CART } = ReorderConstants;
  const [isModalOpen, setModalOpen] = useState(reorderModalOpen);
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const [tender, setTender] = useState({ name: '', payload: {} });
  const [paymentEnabled, setPaymentEnabled] = useState(false);
  const [openModal, toggleModal] = useState(false);
  const [userPhone, setUserPhone] = useState();
  const [userEmail, setUserEmail] = useState();
  const [isValid, setIsValid] = useState(false);
  const [formPayload, setFormPayload] = useState({});

  const [isClickAddPayment, setIsClickAddPayment] = useState(false);
  const history = useHistory();
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const { TENDER_DATA, PAYMENET_FORM_PAYLOAD } = StartOrderContants;
  const { cartReducer, tenantReducer, profileReducer } = useSelector(data => {
    return data;
  });
  const { tenantId } = tenantReducer;
  const { cartData = {}, isValidated = false, isBasketAdded } = cartReducer;
  const customerDetails = profileReducer?.basic;
  const { discountLines = [], id: basketId } = cartData || {};

  const getCustomerDetails = () => {
    const { phone, email } = getUserDetails(customerDetails);
    setUserPhone(phone);
    setUserEmail(email);
    const userData = Boolean(email || phone);
    setPaymentEnabled(userData);
  };

  useEffect(() => {
    isEmptyObject(customerDetails) && userParams.loggedIn && getCustomerDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerDetails]);

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  }, [isMobile]);

  const cancelConformation = () => {
    dispatch(
      removeAllItemAction({
        basketId,
        tenantId,
      }),
    );
    setQuickReorderModalOpen(false);
    setReorderModalOpen(false);
    /* resetting false value to reorderClick, to show the toast onclick add to cart button*/
    sessionStorage.setItem('reorderClick', false);
  };

  const modalProps = {
    id: 'reorderModal',
    role: 'dialog',
    modalTitleId: 'reorderModal',
    show: isModalOpen,
    classNames: `Base-modal ${isMobile ? 'mobile-reorder-modal' : 'reorder-modal'}`,
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: () => setReorderModalOpen(false),
    modalTitle: '',
    modalTitleRequired: false,
    closeDataTestId: 'close-modal',
    autoFocus: true,
  };

  const quickReorderModalProps = {
    id: 'QuickReorderModal',
    role: 'dialog',
    modalTitleId: 'QuickReorder',
    show: isQuickReorderModalOpen,
    classNames: `Base-modal ${isMobile ? 'mobile-QuickReorder-modal' : 'QuickReorder-modal'}`,
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: cancelConformation,
    modalTitle: translateWithI18Next(QUICK_ORDER),
    closeDataTestId: 'close-quick-reorder-modal',
    autoFocus: true,
  };
  const [modalClose, setModalClose] = useState(false);
  const continuePaymentPlaceOrderClickHandler = (currencyConversionFactor, reOrderObj, reOrderAnalyticHandlerFn) => {
    reOrderAnalyticHandlerFn(currencyConversionFactor, reOrderObj);
    addToPaymentClickHandler(
      paymentEnabled,
      isClickAddPayment,
      setIsClickAddPayment,
      setFormPayload,
      userEmail,
      userPhone,
      setTender,
      null,
      null,
    );
    setModalClose(true);
    /* resetting false value to reorderClick, to show the toast onclick add to cart button*/
    sessionStorage.setItem('reorderClick', false);
  };

  const onContinueHandler = () => {
    if (discountLines.length > 0 && basketId) {
      let discountLinesId = discountLines.map(discItem => discItem.id);
      dispatch(
        removeAllCouponAction(
          {
            params: {
              basketId,
            },
            tenantId: tenantId,
            shouldClearCart: true,
          },
          discountLinesId,
        ),
      );
    } else if (basketId) {
      dispatch(
        removeAllItemAction({
          basketId,
          tenantId: tenantId,
        }),
      );
    }
    setQuickReorderModalOpen(true);
    setModalOpen(false);
  };

  const onSubmitHandler = () => {
    history.push({ pathname: `/${CHECKOUT}` });
  };

  const setTenderHandler = value => {
    setTender(value);
    userOrderStateDispatch({
      type: TENDER_DATA,
      value: {
        tenderInfo: value,
        isPaymentAdded: true,
      },
    });
  };

  const setFormPayloadHandler = value => {
    setFormPayload(value);
    userOrderStateDispatch({
      type: PAYMENET_FORM_PAYLOAD,
      value: {
        paymentFormPayload: value,
      },
    });
  };

  const closeCoupenModal = value => {
    if (value === 'true') {
      history.push({ pathname: `/${CART}` });
      /* resetting false value to reorderClick, to show the toast onclick add to cart button*/
      sessionStorage.setItem('reorderClick', false);
    } else {
      setModalClose(false);
      toggleModal(false);
      setQuickReorderModalOpen(true);
    }
  };

  return (
    <>
      {isModalOpen && (
        <Modal {...modalProps}>
          <ReorderConfirmationModel onCancel={() => setReorderModalOpen(false)} onContinue={onContinueHandler} />
        </Modal>
      )}

      {isQuickReorderModalOpen && !modalClose && (
        <Modal {...quickReorderModalProps}>
          <QuickReorderModal
            storeInfo={storeInfo}
            cartData={cartData}
            onCancel={cancelConformation}
            onContinue={continuePaymentPlaceOrderClickHandler}
            isBasketAdded={isBasketAdded}
            onAddCoupon={(currencyConversionFactor, reOrderObj, reOrderAnalyticHandlerFn) => {
              reOrderAnalyticHandlerFn(currencyConversionFactor, reOrderObj);
              toggleModal(true);
              setModalClose(true);
            }}
          />
        </Modal>
      )}

      <ProceedToPayment
        isClickAddPayment={isClickAddPayment}
        setIsClickAddPayment={setIsClickAddPayment}
        onSubmit={onSubmitHandler} //
        onClose={() => {
          setReorderModalOpen(false);
          setModalClose(false);
          setQuickReorderModalOpen(false);
        }}
        cartData={cartData}
        isValidated={isValidated}
        basketId={cartData?.id}
        tenantId={tenantId}
        tender={tender}
        setTender={value => setTenderHandler(value)}
        isValid={isValid}
        setIsValid={setIsValid}
        formPayload={formPayload}
        setFormPayload={value => setFormPayloadHandler(value)}
      ></ProceedToPayment>
      {openModal && (
        <CouponsModal
          data-testid='coupon-modal'
          bucketId={basketId}
          isOpen={openModal}
          handleClose={closeCoupenModal}
        />
      )}
    </>
  );
};

export default ReorderComponent;
